import { render, staticRenderFns } from "./NewIcon.vue?vue&type=template&id=275a3542&scoped=true"
import script from "./NewIcon.vue?vue&type=script&lang=ts"
export * from "./NewIcon.vue?vue&type=script&lang=ts"
import style0 from "./NewIcon.scss?vue&type=style&index=0&id=275a3542&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275a3542",
  null
  
)

export default component.exports